import { render, staticRenderFns } from "./CandidateBigSlider.vue?vue&type=template&id=de9dc71e&"
import script from "./CandidateBigSlider.vue?vue&type=script&lang=js&"
export * from "./CandidateBigSlider.vue?vue&type=script&lang=js&"
import style0 from "./CandidateBigSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VSlideGroup,VSlideItem})
